import { render, staticRenderFns } from "./DashboardUnderperformingGraduateItem.vue?vue&type=template&id=4a8edbb8&"
import script from "./DashboardUnderperformingGraduateItem.vue?vue&type=script&lang=js&"
export * from "./DashboardUnderperformingGraduateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports